import { render, staticRenderFns } from "./SettingsFeatures.vue?vue&type=template&id=4608b364&scoped=true"
import script from "./SettingsFeatures.vue?vue&type=script&lang=js"
export * from "./SettingsFeatures.vue?vue&type=script&lang=js"
import style0 from "./SettingsFeatures.vue?vue&type=style&index=0&id=4608b364&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4608b364",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4608b364')) {
      api.createRecord('4608b364', component.options)
    } else {
      api.reload('4608b364', component.options)
    }
    module.hot.accept("./SettingsFeatures.vue?vue&type=template&id=4608b364&scoped=true", function () {
      api.rerender('4608b364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsFeatures.vue"
export default component.exports